<div style="position: relative; z-index: 50; width: 100%;bottom: 1em;" class="container-barchar">
  @for (indicator of indicators; track indicator) {
    <div>
      @if ((indicatorSelected === indicator.name)) {
        <div>
          @if (doTransformData) {
            <app-chart chartType="bar" [ip]="ip" [deudaOrMora]="deudaOrMora" [isLoading]="isLoading" [labels]="rangeLabels"
              [data]="rangeData | toCartesian:rangeLabels | transformData">
            </app-chart>
          }
          @if (!doTransformData) {
            <app-chart chartType="bar" [ip]="ip" [deudaOrMora]="deudaOrMora" [isLoading]="isLoading" [labels]="rangeLabels"
              [data]="rangeData">
            </app-chart>
          }
        </div>
      }
    </div>
  }
</div>
